export const latitudeRegex = /^-?(90([.,]\d{1,6})?|[0-8]?\d([.,]\d{1,6})?)$/;

export const validateLatitude = (latitude: string) => {
  const regex = new RegExp(latitudeRegex);
  return regex.test(latitude);
};
